import React, { useState, useEffect } from 'react';
import {
    List, Datagrid, TextField, FunctionField, SimpleList
} from 'react-admin';
import {
    useMediaQuery, makeStyles, Button
} from '@material-ui/core';
import { customTheme } from "./customTheme";
import CustomSearch from './components/CustomSearch';
import { useLocation } from 'react-router-dom';
import CustomPagination from './components/CustomPagination';
import ScrollableTable from './components/ScrollableTable';
import UseAnalyticsEvent from './utils/useAnalyticsEvent';
import { fastagIssuers } from "./sharedData";
import ParkSmartTag from './images/parksmartTag.png'


const useStyles = makeStyles({
    list: {
        marginBottom: 0,
    },
    parkingSelectorContainer: {
        display: "grid",
        justifyContent: "space-between",
    },
    chipCell: {
        textAlign: "center",
        padding: customTheme.spacing(1, 2),
        display: "inline-block",
        borderRadius: 50,
    }
});

const CATEGORY = "FASTAG SECTION"

const STATUS_COLORS = {
    "ACTIVE": "#18cc69",
    "INACTIVE": "#de575e",
};

const getFastagIssuerId = (tagId) => {
    if (RegExp("^918907048").test(tagId)) {
        return "607417";
    } else {
        let tagIdBin = "";
        for (let i = 0; i < tagId.length; i++) {
            tagIdBin += (parseInt(tagId[i], 16).toString(2)).padStart(4, "0");
        }
        const issuerId = parseInt(tagIdBin.substr(43, 20), 2).toString();
        return issuerId;
    }
};

const renderTagImageDataGrid = record => {
    if (!record) return '-'
    if (record && (record['rfid'] == null || record['rfid'] === '')) return '-'

    let fix = record["rfid"] ? record["rfid"] : ""
    const issuerId = getFastagIssuerId(fix);
    const issuer = fastagIssuers[issuerId] ? fastagIssuers[issuerId] : null;
    if (typeof issuer === "string") {
        return <div style={{ display: 'flex', alignItems: "center", justifyContent: "center" }}>
            <img src={`/images/${issuer.replace(/\s/g, "")}.png`} alt={issuer} style={{ width: 75, borderRadius: 5, border: "1px solid #aaa" }} />
        </div>
    }
    else if (typeof record.tag_id === "string" && record.tag_id !== "") {
        return <div style={{ display: 'flex', alignItems: "center", justifyContent: "center" }}>
            <img src={ParkSmartTag} alt="ParkSmart" style={{ width: 75, borderRadius: 5, display: "block", margin: "auto" }} />
        </div>
    }
    else
        return "-"
};

export const FastagsStatus = props => {
    const eventTracker = UseAnalyticsEvent();
    const classes = useStyles();
    const location = useLocation();
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    let prevSearch = sessionStorage.getItem(location.pathname) ? JSON.parse(sessionStorage.getItem(location.pathname)) : ""
    const [search, setSearch] = useState(prevSearch.inputSearch)
    let searchTypeState = ["Vehicle Number", "RFID Tag"]
    const [searchTypes, setSearchTypes] = useState(prevSearch.type ? prevSearch.type : "Vehicle Number");
    const [filter , setFilter] = useState({})

    const serachHandler = () =>{
        setFilter({ search: { value: search ? search : "", type: searchTypes ? searchTypes : "" } })
    }

    useEffect(() => {
        eventTracker(CATEGORY, "FASTAGS LIST")
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return <div className={classes.list}>

        <div className='customStyleForDataSearchDiv' style={{marginBottom:20}}>
            <CustomSearch search={search} setSearch={setSearch} searchTypes={searchTypes} setSearchTypes={setSearchTypes} searchTypeState={searchTypeState} pathName={location.pathname} placeholder={`Enter your ${searchTypes}`} />
            <div style={{ display: "flex", alignItems: "center", marginLeft:20}}>
                <Button
                    onClick={serachHandler}
                    color="primary"
                    variant="contained"
                    style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "42px", minWidth: "160px", backgroundColor: "#18CC69", color: "#FFF", borderRadius:10, cursor:'pointer' }}
                    disableElevation
                    disabled={!search}
                >
                    Search
                </Button>
            </div>
        </div>
       
        <List
            {...props}
            title="Fastags Status"
            bulkActionButtons={false}
            exporter={false}
            filter={filter}
            empty={false}
            pagination={<CustomPagination />}
            actions={false}
        >
            {
                isSmallDevice ?
                    <SimpleList
                        primaryText={record => record.vehicle_number}
                        secondaryText={record => (<div>
                            {record.rfid && <div><span style={{ color: "#5a5a5a" }}>RFID: </span>{record.rfid}</div>}
                            {record.tid && <div><span style={{ color: "#5a5a5a" }}>TID: </span>{record.tid}</div>}
                            {record.vehicle_class && <div><span style={{ color: "#5a5a5a" }}>Vehicle Class: </span>{record.vehicle_class}</div>}
                            {record.exc_code && <div><span style={{ color: "#5a5a5a" }}>Exc Code: </span>{record.exc_code}</div>}
                            {record.com_vehicle && <div><span style={{ color: "#5a5a5a" }}>Com Vehicle: </span>{record.com_vehicle}</div>}
                            {record.status && <div style={{color: STATUS_COLORS[record.status]}}><span style={{ color: "#5a5a5a" }}>Status: </span>{record.rfid}</div>}
                            {record.fastag_provider && <div><span style={{ color: "#5a5a5a" }}>Fastag Provider: </span>{record.fastag_provider}</div>}
                        </div>)}
                        onContextMenu={event => event.preventDefault()}
                        linkType={false}
                        rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                    />
                    :
                    <Datagrid component={ScrollableTable}>
                        <TextField source='vehicle_number' label="Vehicle Number" />
                        <TextField source='rfid' label="RFID" />
                        <TextField source='tid' label="TID" />
                        <FunctionField label="Fastag Provider" render={record => record && renderTagImageDataGrid(record)}/>
                        <FunctionField
                        source="status"
                        label="Status"
                        render={record => record &&
                            <div
                                className={classes.chipCell}
                                style={STATUS_COLORS[record.status] ? { color: STATUS_COLORS[record.status], backgroundColor: (STATUS_COLORS[record.status] + "19") } : { color: "#555555", backgroundColor: "#55555519" }}
                            >
                                {record.status}
                            </div>
                        }
                        sortable={true}
                        style={{ display: "flex", justifyContent: "center" }}
                    />
                        <TextField source='vehicle_class' label="Vehicle Class" />
                        <TextField source='exc_code' label="Exc Code" />
                        <TextField source='com_vehicle' label="Com Vehicles" />
                        
                    </Datagrid>
            }
        </List>
    </div>
};